import { FormField, SectionDivider, SelectBox } from '@domain-group/suit-theme'

import type { ProviderPriceListItemModel } from '@models/types'

import type { SelectedOption } from '@functions/selectPriceListItemOptionValue'

import filterPriceListItemOptionValuesByOption from './functions/filterPriceListItemOptionValuesByOption'

import useProductOptionsSelector from './hooks/useProductOptionsSelector'

interface ProductOptionsSelectorProps {
  callbacks: {
    selectProviderPriceListItemId: (id: number) => void,
    selectProviderPriceListItemOptionValue: (params: object) => void,
  },
  optionFormFieldBoxProps?: object,
  providerPriceListItems: ProviderPriceListItemModel[],
  quantityFormFieldBoxProps?: object,
  selectedProviderPriceListItemOptions: SelectedOption[],
  selectedProviderPriceListItemId: number,
}

const ProductOptionsSelector = (props: ProductOptionsSelectorProps) => {
  const {
    callbacks: {
      selectProviderPriceListItemId,
      selectProviderPriceListItemOptionValue,
    },
    optionFormFieldBoxProps,
    providerPriceListItems,
    quantityFormFieldBoxProps,
    selectedProviderPriceListItemOptions,
    selectedProviderPriceListItemId,
  } = props

  const productOptionsSelectorPayload = useProductOptionsSelector({
    selectedProviderPriceListItemId,
  })

  const {
    filteredProviderPriceListItemOptions,
    providerPriceListItemOptionValues,
  } = productOptionsSelectorPayload

  return (
    <>
      <FormField
        direction="column"
        // @ts-expect-error TS2322
        flexShrink="0"
        label="Select Quantity"
        marginTop="large"
        {...quantityFormFieldBoxProps}
      >
        <SelectBox
          callbacks={{ selectItem: (item: { key: number }) => selectProviderPriceListItemId(item.key) }}
          items={providerPriceListItems.map(priceListItem => ({
            key: priceListItem.id,
            title: `${priceListItem.quantity}`,
          }))}
          selectedItemKey={selectedProviderPriceListItemId}
          style={{ zIndex: 13 }}
        />
      </FormField>

      {!!filteredProviderPriceListItemOptions.length && (
        <>
          <SectionDivider boxProps={{ marginTop: 'large' }}>
            Product Options
          </SectionDivider>

          {filteredProviderPriceListItemOptions.map((priceListItemOption, index) => {
            const { id, title } = priceListItemOption

            const filteredOptionValues = filterPriceListItemOptionValuesByOption({
              providerPriceListItemOption: priceListItemOption,
              providerPriceListItemOptionValues,
            })

            const selected = selectedProviderPriceListItemOptions.find(currentOption => (
              currentOption.id === priceListItemOption.id
            ))

            const selectedOptionValueId = selected?.value?.id

            // add vertical scroll to SelectBoxes when there are 3+ options.
            // scroll is needed when options extend past the footer and are hidden
            const selectBoxScrollStyle = filteredOptionValues.length > 3 ? {
              maxHeight: '120px',
              overflowY: 'scroll',
            } : null

            return (
              <FormField
                direction="column"
                // @ts-expect-error TS2322
                flexShrink="0"
                key={id}
                label={title}
                marginTop="large"
                {...optionFormFieldBoxProps}
              >
                <SelectBox
                  callbacks={{
                    // @ts-expect-error TS7006
                    selectItem: item => selectProviderPriceListItemOptionValue({
                      providerPriceListItemOption: priceListItemOption,
                      providerPriceListItemOptionValueId: item.key,
                    }),
                  }}
                  items={filteredOptionValues.map(optionValue => ({
                    key: optionValue.id,
                    price: optionValue.price,
                    title: `${optionValue.title}`,
                  }))}
                  selectedItemKey={selectedOptionValueId}
                  style={{ zIndex: 12 - index }}
                  ulStyle={selectBoxScrollStyle}
                />
              </FormField>
            )
          })}
        </>
      )}
    </>
  )
}

export default ProductOptionsSelector
